<template>
  <b-modal id="modal-list-share" size="lg" title="Share this list">
    <div id="share-account-manager">
      <h6>Send to your account manager</h6>
      <b-link v-b-toggle.collapse-account-manager>Add message...</b-link><br />
      <b-collapse id="collapse-account-manager" class="mt-2">
        <b-textarea v-model="manager_message"></b-textarea>
      </b-collapse>
      <b-button class="mt-2" variant="primary" size="sm"
        >Send to account manager</b-button
      >
      <hr />
    </div>

    <div id="share-email">
      <h6>Share via email</h6>
      <b-link v-b-toggle.collapse-email>Add message...</b-link><br />
      <b-collapse id="collapse-email" class="mt-2">
        <b-textarea v-model="email_message"></b-textarea>
      </b-collapse>
      <b-form-input
        class="mt-2"
        placeholder="Email Address"
        v-model="email"
        type="email"
      ></b-form-input>
      <b-button class="mt-2" variant="primary" size="sm" @click="send_email"
        >Send</b-button
      >
      <hr />
    </div>

    <div id="share-link">
      <h6>Share via link</h6>

      <b-input-group class="mb-3" size="sm">
        <b-form-input
          id="share-url"
          type="text"
          :value="url"
          readonly
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" text="Button" @click="copy" variant="primary"
            >Copy to clipboard</b-button
          >
        </b-input-group-append>
      </b-input-group>
    </div>
  </b-modal>
</template>

<script>
import jbs_api from "@/modules/jbs-api";

export default {
  props: {
    listSlug: {
      type: String,
    },
  },
  methods: {
    send_email_account_manager() {
      jbs_api
        .post("WineList/Share", {
          slug: this.listSlug,
          message: this.manager_message,
        })
        .then(() => {
          this.$bvModal.msgBoxOk("Message sent!").then(() => {
            this.$bvModal.hide("modal-list-share");
          });
        })
        .catch(() => {
          this.showError(
            "There was a problem sharing this list via email",
            "Please try again later."
          );
        });
    },
    send_email() {
      jbs_api
        .post("WineList/Share", {
          slug: this.listSlug,
          message: this.email_message,
          email: this.email,
        })
        .then(() => {
          this.$bvModal.msgBoxOk("Message sent!").then(() => {
            this.$bvModal.hide("modal-list-share");
          });
        })
        .catch(() => {
          this.showError(
            "There was a problem sharing this list via email",
            "Please try again later."
          );
        });
    },
    copy() {
      var el = document.querySelector("#share-url");
      el.select();

      document.execCommand("copy");

      window.getSelection().removeAllRanges();
    },
  },
  computed: {
    url() {
      return (
        window.location.protocol +
        "//" +
        window.location.hostname +
        "/wine-list/view/" +
        this.listSlug
      );
    },
  },
  data() {
    return {
      email: "",
      email_message: "",
      manager_message: "",
    };
  },
};
</script>